import BaseModel from "lib/model";
import me from "models/me";

export default BaseModel.extend({
    idAttribute: "sku_id",
    props: {
        sku_id: "objectId",
        available: { type: "number", required: false },
        display_quantity: { type: "string", required: true },
    },
    session: {
        quantity: { type: "number", default: 0 },
    },

    isValidQuantity(quantity) {
        const canOversell = me.hasPermission("can_oversell");
        const isPositiveNumber = !isNaN(quantity) && Number(quantity) >= 0;
        if (canOversell) {
            return isPositiveNumber;
        } else {
            return isPositiveNumber && this.available >= quantity;
        }
    },
});
